((app, ng) => {

    app.config($stateProvider => {
        $stateProvider.state("Home.Accounts",
            {
                url: "/Accounts",
                component: "accounts",
                resolve: {
                    figXref: agentXrefApi => agentXrefApi.getFigXref().catch(ng.noop),
                    acmXref: agentXrefApi => agentXrefApi.getAcmXref().catch(ng.noop),
                    parentFigXrefs: agentXrefApi => agentXrefApi.getParentFigXrefs(),
                    parentAcmXrefs: agentXrefApi => agentXrefApi.getParentAcmXrefs(),
                },
                data: {
                    pageTitle: "Accounts",
                },
                redirectTo: "Home.Accounts.All",
            });
    });

    app.component("accounts",
        {
            templateUrl: "/App/Accounts/accounts.html",
            controller: accountsController,
            bindings: {
                figXref: "<",
                acmXref: "<",
                parentFigXrefs: "<",
                parentAcmXrefs: "<",
            }
        });

    function accountsController() {
        const $ctrl = this;

        this.$onInit = () => {
            $ctrl.ui = {
                loading: true,
            }
        }
    }

})(window.app, window.angular);